import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

function ModalLink({ title, children }) {
  return (
    <Dialog>
      <DialogTrigger 
        className="hover:text-neutral-900 underline underline-offset-4 decoration-black/20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-sm"
        aria-label={`${title} öffnen`}
      >
        {title}
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogTitle className="text-xl font-bold">{title}</DialogTitle>
        <DialogDescription asChild>
          <div className="prose prose-sm max-w-none mt-4 text-neutral-700 space-y-4">
            {children}
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}

export default function ImpressumLinks() {
  return (
    <div className="flex gap-6">
      <ModalLink title="Impressum">
        <div>
          <h3 className="text-lg font-semibold mb-3">Angaben gemäß § 5 TMG</h3>
          
          <div className="mb-4">
            <strong>HAK Sportcars – KFZ‑Sachverständigenbüro</strong><br />
            Athanasios Stefanidis<br />
            Oskar‑Jäger‑Str. 145<br />
            50825 Köln
          </div>

          <div className="mb-4">
            <strong>Kontakt:</strong><br />
            Telefon: +49 1523 6373696<br />
            E‑Mail: info@haksportcars-gutachten.de
          </div>


          <div className="mb-4">
            <strong>Berufsbezeichnung und berufsrechtliche Regelungen:</strong><br />
            Berufsbezeichnung: KFZ-Sachverständiger<br />
            Verliehen in: Deutschland
          </div>

          <div className="mb-4">
            <strong>Mitgliedschaft:</strong><br />
            Mitglied im Bundesverband der freiberuflichen und unabhängigen Sachverständigen für das Kraftfahrzeugwesen, Handel und Verwertung e.V. (BVkSH)
          </div>

          <div className="mb-4">
            <strong>Redaktionell verantwortlich:</strong><br />
            Athanasios Stefanidis<br />
            Oskar‑Jäger‑Str. 145<br />
            50825 Köln
          </div>

          <div className="mb-4">
            <strong>Streitschlichtung:</strong><br />
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline ml-1">
              https://ec.europa.eu/consumers/odr/
            </a><br />
            Unsere E‑Mail‑Adresse finden Sie oben im Impressum.<br /><br />
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </div>

          <div className="mb-4">
            <strong>Haftung für Inhalte:</strong><br />
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </div>

          <div className="mb-4">
            <strong>Haftung für Links:</strong><br />
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </div>

          <div>
            <strong>Urheberrecht:</strong><br />
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </div>
        </div>
      </ModalLink>

      <ModalLink title="Datenschutz">
        <div>
          <h3 className="text-lg font-semibold mb-3">Datenschutzerklärung</h3>
          
          <div className="mb-4">
            <h4 className="font-semibold">1. Datenschutz auf einen Blick</h4>
            <p><strong>Allgemeine Hinweise</strong><br />
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">2. Allgemeine Hinweise und Pflichtinformationen</h4>
            <p><strong>Datenschutz</strong><br />
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
            
            <p><strong>Verantwortliche Stelle</strong><br />
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br />
            HAK Sportcars – KFZ‑Sachverständigenbüro<br />
            Athanasios Stefanidis<br />
            Oskar‑Jäger‑Str. 145<br />
            50825 Köln<br />
            Telefon: +49 1523 6373696<br />
            E‑Mail: info@haksportcars-gutachten.de</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">3. Datenerfassung auf dieser Website</h4>
            <p><strong>Cookies</strong><br />
            Diese Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.</p>
            
            <p><strong>Server-Log-Dateien</strong><br />
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage, IP-Adresse.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">4. Kontaktformular und E-Mail-Kontakt</h4>
            <p>Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">5. Ihre Rechte</h4>
            <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">6. Analyse-Tools und Werbung</h4>
            <p>Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit so genannten Analyseprogrammen. Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.</p>
          </div>

          <div>
            <h4 className="font-semibold">7. SSL- bzw. TLS-Verschlüsselung</h4>
            <p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>
          </div>
        </div>
      </ModalLink>

      <ModalLink title="AGB">
        <div>
          <h3 className="text-lg font-semibold mb-3">Allgemeine Geschäftsbedingungen</h3>
          
          <div className="mb-4">
            <h4 className="font-semibold">§ 1 Geltungsbereich und Anbieter</h4>
            <p>Diese Allgemeinen Geschäftsbedingungen gelten für alle Leistungen der HAK Sportcars – KFZ‑Sachverständigenbüro, Athanasios Stefanidis, Oskar‑Jäger‑Str. 145, 50825 Köln im Bereich der KFZ-Sachverständigentätigkeit.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 2 Leistungsumfang</h4>
            <p>Unsere Leistungen umfassen die Erstellung von KFZ-Gutachten, Schadensbewertungen, Unfallrekonstruktionen und beratende Tätigkeiten im Bereich des Kraftfahrzeugwesens. Die konkreten Leistungen ergeben sich aus dem jeweiligen Auftrag.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 3 Vertragsschluss</h4>
            <p>Der Vertrag kommt durch schriftliche oder mündliche Beauftragung und unsere Annahme zustande. Bei Eilaufträgen kann die Annahme auch durch Beginn der Leistungserbringung erfolgen.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 4 Preise und Zahlungsbedingungen</h4>
            <p>Es gelten unsere zum Zeitpunkt der Beauftragung gültigen Preise. Sofern nicht anders vereinbart, sind unsere Rechnungen innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zur Zahlung fällig. Bei Zahlungsverzug werden Zinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz berechnet.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 5 Durchführung der Leistungen</h4>
            <p>Wir führen unsere Leistungen nach den anerkannten Regeln der Technik und mit der gebotenen Sorgfalt durch. Terminabsprachen sind, soweit nicht ausdrücklich als verbindlich vereinbart, unverbindliche Schätzungen.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 6 Mitwirkungspflichten des Auftraggebers</h4>
            <p>Der Auftraggeber hat uns alle für die Durchführung des Auftrags notwendigen Informationen und Unterlagen vollständig und wahrheitsgemäß zur Verfügung zu stellen. Er hat dafür zu sorgen, dass das zu begutachtende Fahrzeug zu den vereinbarten Terminen zugänglich ist.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 7 Gewährleistung und Haftung</h4>
            <p>Wir haften nur für Vorsatz und grobe Fahrlässigkeit. Bei leichter Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten und nur bis zur Höhe des vorhersehbaren, typischen Schadens. Die Haftung für mittelbare Schäden und entgangenen Gewinn ist ausgeschlossen.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 8 Aufbewahrung und Rückgabe von Unterlagen</h4>
            <p>Uns überlassene Unterlagen bewahren wir sorgfältig auf und geben sie nach Abschluss des Auftrags zurück. Nach Ablauf von 6 Jahren sind wir berechtigt, Unterlagen zu vernichten, sofern nicht gesetzliche Aufbewahrungspflichten entgegenstehen.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 9 Vertraulichkeit</h4>
            <p>Wir verpflichten uns zur Verschwiegenheit über alle uns im Rahmen der Auftragsabwicklung bekannt gewordenen Geschäfts- und Betriebsgeheimnisse des Auftraggebers.</p>
          </div>

          <div className="mb-4">
            <h4 className="font-semibold">§ 10 Schlussbestimmungen</h4>
            <p>Es gilt deutsches Recht. Gerichtsstand ist Köln. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
          </div>

          <div>
            <p className="text-sm text-gray-600 mt-6">Stand: Januar 2025</p>
          </div>
        </div>
      </ModalLink>
    </div>
  );
}



